import { render, staticRenderFns } from "./goodsChangeApplication.vue?vue&type=template&id=5fc7bb5c&scoped=true&"
import script from "./goodsChangeApplication.vue?vue&type=script&lang=js&"
export * from "./goodsChangeApplication.vue?vue&type=script&lang=js&"
import style0 from "./goodsChangeApplication.vue?vue&type=style&index=0&id=5fc7bb5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7bb5c",
  null
  
)

export default component.exports